var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38462 3.76929C2.01739 3.76929 1.66521 3.91517 1.40554 4.17483C1.14588 4.4345 1 4.78668 1 5.1539V17.6154C1 17.9827 1.14588 18.3348 1.40554 18.5945C1.66521 18.8542 2.01739 19.0001 2.38462 19.0001H17.6154C17.9826 19.0001 18.3348 18.8542 18.5945 18.5945C18.8541 18.3348 19 17.9827 19 17.6154V5.1539C19 4.78668 18.8541 4.4345 18.5945 4.17483C18.3348 3.91517 17.9826 3.76929 17.6154 3.76929H14.8462",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.30762H19",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15381 1V6.53846",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8462 1V6.53846",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15381 3.76929H12.0769",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.d4ab7f25.svg";
export { ForwardRef as ReactComponent };